/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of a chat message.
 */
export enum ChatMessageStatus {
    NOT_READ = 'NOT_READ',
    READ = 'READ',
    ANSWERED = 'ANSWERED',
    BOUGHT = 'BOUGHT',
}
